// ENUMS ##########################################################
export enum PagingModeEnum {
	Full = 'full',
	Light = 'light',
}


// DECLARATIONS ###################################################


// INTERFACES #####################################################
export interface IPaging {

	blockOperationEmit?: boolean;

	pageCount?: number;

	pageNumber: number;

	pageSize: number;

	resetPaging?: boolean;

	totalElements?: number;

	uiListResultIsSmallerAsPageSize?: boolean;
}

export interface IPagingData {
	mode: PagingModeEnum;

	continuesPagesMode: boolean;

	defaultValues: IPaging;
}

// TYPES ##########################################################


// Paging ################################################


// CLASSES ########################################################
